import { Space } from 'antd'
import AppDnD from 'general/components/AppDragAndDrop/AppDnD'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
// import SelectOptions from 'general/constants/SelectOptions'
import Utils, { findObjectInArray } from 'general/utils/Utils'
import useFilter from 'hooks/useFilter'
// import { useMemo } from 'react'
import { InvoiceTable } from '../../components/InvoiceTable'
import Modals from '../../components/Modals'
import {
  defaultValues,
  defaultValuesAD,
  filterOptions,
  renderInvoiceType,
} from '../../constant'
import useAppDnD from 'hooks/useAppDnD'
import useGetSerials from 'hooks/Queries/useGetSerials'
// import SelectOptions from 'general/constants/SelectOptions'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import CustomAntSelect from 'general/components/CustomAntSelect'
import { useEffect, useState } from 'react'
import useSearchDebounce from 'hooks/useSearchDebounce'
import {
  useCopyQueryListInvoice,
  useMutationPullBulkMessage,
  useQueryListAccountingDocument,
  useQueryListCompany,
  useQueryListInvoice,
} from '../../components/queries'
import _ from 'lodash'
// import { useMutationGetBulkMessage } from 'features/Invoice/screens/ListInvoice/queries'
import { ActionsTable } from '../../components/InvoiceTable/ActionsTable'
import dayjs from 'dayjs'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import { useAppSelector } from 'hooks/useRedux'
import { shallowEqual } from 'react-redux'
import { useTransactionSelector } from 'features/Invoice/screens/ListTransactions/slice'
import { useDispatch } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'
import { thunkFindJobposition } from 'features/Jobposition/jobpositionSlice'
import {
  thunkCopys,
  thunkChangeStatusRemoveInvoice,
  setSelectedAccountingDocument,
} from 'features/Invoice/invoiceSlice'
import ToastHelper from 'general/helpers/ToastHelper'
import axiosClient from 'api/axiosClient'
import reportApi from 'api/reportApi'
import { saveAs } from 'file-saver'
import CustomDataTable from 'general/components/CustomDataTable'
import ModalCompanyConfigs from 'features/TvanHandle/components/ModalCompanyConfigs'
import TableAction from 'general/components/GroupButton/TableAction'
import { IconAction } from 'general/components/GroupButton/styles'
import SelectOptions from 'general/constants/SelectOptions'
import { SpanNotYetReleasedTd } from 'features/TaxDeductionDocuments/styled'
import { thunkCopyAccountingDocuments } from 'features/AccountingDocument/accountDoucmentsSlice'
export const TvanHandleAccountingDocument = () => {
  // base state
  const [tvanState, setTvanState] = useState({ show: false, value: false })
  const [modalsState, setModalsState] = useState({})
  const [disableCopy, setDisableCopy] = useState(false)
  const [disableExport, setDisableExport] = useState(false)
  const [
    disableChangeStatusRemoveInvoice,
    setDisableChangeStatusRemoveInvoice,
  ] = useState(false)
  const [filterParams, setFilterParams] = useFilter(
    'TvanHandle',
    'gFiltersTvanHandle',
  )
  const { mutate: checkMessages, isPending: checkingBulkMessage } =
    useMutationPullBulkMessage()

  const defaultColumns = [
    {
      id: 'nnt',
      name: 'Tên người nộp thuế',
      minWidth: '200px',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            // style={{
            //   textAlign: 'center',
            // }}
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            <span>{row?.taxpayersName}</span>
          </p>
        )
      },
    },
    {
      id: 'mst',
      name: 'Mã số thuế/CCCD',
      minWidth: '150px',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            style={{
              textAlign: 'center',
            }}
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.employeeTaxCode}/
            <span style={{ color: 'blue' }}>{row?.employeeIdentification}</span>
          </p>
        )
      },
    },
    // {
    //   id: 'companyPhone',
    //   name: 'Số điện thoại',
    //   minWidth: '120px',
    //   center: true,
    //   omit: false,
    //   cell: (row) => {
    //     return (
    //       <p
    //         style={{
    //           textAlign: 'center',
    //         }}
    //         data-tag="allowRowEvents"
    //         className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
    //       >
    //         {`${row?.companyPhone ?? ''}`}
    //       </p>
    //     )
    //   },
    // },
    // {
    //   id: 'companyAddress',
    //   name: 'Địa chỉ',
    //   minWidth: '250px',
    //   center: true,
    //   omit: false,
    //   cell: (row) => {
    //     return (
    //       <p
    //         style={{
    //           textAlign: 'center',
    //         }}
    //         data-tag="allowRowEvents"
    //         className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
    //       >
    //         {row?.companyAddress}
    //       </p>
    //     )
    //   },
    // },
    {
      id: 'sct',
      name: 'Số chứng từ',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.numberDocument}
          </p>
        )
      },
    },
    {
      id: 'mauchungtu',
      name: 'Mẫu chứng từ',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {`${row?.templatePaper?.symbolCode}/${row?.templatePaper?.symbolYear}${row?.templatePaper?.symbolType}`}
          </p>
        )
      },
    },
    {
      id: 'tranthaiphathanh',
      name: 'Trạng thái chứng từ',
      center: true,
      omit: false,
      minWidth: '170px',
      cell: (row) => {
        const constStatus = findObjectInArray(
          SelectOptions.listStatusTaxAccountingDocuments,
          'value',
          row.statusSendTax != null ? row.statusSendTax : -1,
        )
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            <SpanNotYetReleasedTd
              color={constStatus?.color}
              backGroundColor={constStatus?.backGroundColor}
            >
              {constStatus?.label}
            </SpanNotYetReleasedTd>
          </p>
        )
      },
    },
    {
      id: 'trangthaiguiccqt',
      name: 'Trạng thái gửi CQT',
      center: true,
      omit: false,
      minWidth: '170px',
      cell: (row) => {
        const constStatus = findObjectInArray(
          SelectOptions.listStatusAccountingDocuments,
          'value',
          row.status,
        )
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            <SpanNotYetReleasedTd
              color={constStatus?.color}
              backGroundColor={constStatus?.backGroundColor}
            >
              {constStatus?.label}
            </SpanNotYetReleasedTd>
          </p>
        )
      },
    },
    {
      id: 'diachi',
      name: 'Địa chỉ',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.employeeAddress}
          </p>
        )
      },
    },
    {
      name: 'Hành động',
      center: true,
      disabled: true,
      compact: true,
      minWidth: '200px',
      grow: 2,
      style: {
        justifyContent: 'flex-end',
      },
      cell: (row) => {
        // 👇 xử lý logic ở đây
        let data = findObjectInArray(
          companyConfigs,
          'companyId',
          row?.companyId,
        )

        // 👇 sau đó return JSX
        return (
          <></>
          //   <TableAction
          //     titleActionText="Cấu hình hàng hóa không tên"
          //     icon={<IconAction className="fa-solid fa-screwdriver" />}
          //     onClick={() => {
          //       setModalsState({
          //         show: true,
          //         value: { ...row, companyConfig: data },
          //       })
          //     }}
          //   />
        )
      },
    },
  ]
  const dynamicColumns = useAppDnD(defaultColumns)

  const { clearSelectedRows, selectedRows } = useTransactionSelector()

  const handleChange = ({ key, value }) => {
    const cloneTvanState = { ...tvanState }
    cloneTvanState[key] = value
    setTvanState(cloneTvanState)
  }
  const handleChangeModalState = ({ key, value }) => {
    const cloneModasState = { ...modalsState }
    cloneModasState[key] = value
    setModalsState(cloneModasState)
  }
  // hiển thị
  // Gán dữ liệu ban đầu
  useEffect(() => {
    const cloneTvanState = { ...tvanState }
    cloneTvanState.keySearch =
      cloneTvanState.keySearch ?? filterOptions[0].value
    setTvanState(cloneTvanState)
  }, [])

  const dispatch = useDispatch()

  // lấy danh sách hóa đơn
  const { debouncedSearch, search, setSearch } = useSearchDebounce('')
  const {
    listData,
    total,
    copyData,
    companyConfigs,
    isGettingListData,
    isRefetching,
    refetchListInvoice,
  } = useQueryListAccountingDocument({
    ...filterParams,
    [tvanState.keySearch]: debouncedSearch,
    // [tvanState.keySearch]: tvanState.searchValue,
  })

  // Làm mới dữ liệu hóa đơn
  useEffect(() => {
    refetchListInvoice()
  }, [
    filterParams,
    refetchListInvoice,
    tvanState.keySearch,
    tvanState.searchValue,
    debouncedSearch,
  ])

  // const { data: dataCopys, copyRefetch } = useCopyQueryListInvoice({
  //   invoiceIds: [-1],
  // })

  const changeStatusRemoveInvoiceRefetch = async () => {
    setDisableChangeStatusRemoveInvoice(true)
    const invoiceIds = selectedRows.map((item) => item.invoiceId)
    const result = unwrapResult(
      await dispatch(thunkChangeStatusRemoveInvoice({ invoiceIds })),
    )
    setDisableChangeStatusRemoveInvoice(false)
    if (result?.result === 'success') {
      ToastHelper.showSuccess(
        `Cập nhật trạng thái đã xóa cho ${invoiceIds.length} hóa đơn thành công`,
      )
      refetchListInvoice()
    } else {
      ToastHelper.showError(
        `Cập nhật trạng thái đã xóa cho ${invoiceIds.length} hóa đơn thất bại`,
      )
    }
  }

  const buttonGroups = [
    {
      text: 'Nhân bản',
      icon: 'fa-light fa-check',
      color: '#3CC65E',
      onClick: () => {
        copyRefetch()
      },
    },
    // {
    //   text: 'Đổi trạng thái đã xóa',
    //   icon: 'fa-light fa-check',
    //   color: '#ee2334',
    //   onClick: () => {
    //     // changeStatusRemoveInvoiceRefetch()
    //   },
    // },
  ]

  const { selectedAccountingDocument, toggledClearRows, modalStates } =
    useAppSelector((state) => state.invoice, shallowEqual)

  const copyRefetch = async () => {
    setDisableCopy(true)
    const accounting_documentsIds = selectedAccountingDocument.map(
      (item) => item.accounting_documentsId,
    )
    console.log('accounting_documentsIds', accounting_documentsIds)
    const result = unwrapResult(
      await dispatch(thunkCopyAccountingDocuments({ accounting_documentsIds })),
    )
    console.log('result', result)
    setDisableCopy(false)
    if (result?.message === 'success') {
      ToastHelper.showSuccess(
        `Nhân bản ${result.countSucess} chứng từ thành công`,
      )
      refetchListInvoice()
    } else {
      ToastHelper.showError(
        `Nhân bản ${accounting_documentsIds.length} chứng từ thất bại`,
      )
    }
  }

  // Lọc
  // bảng
  // kéo mã
  // chuyển về gửi lỗi
  // cập nhật thông điệp
  return (
    <ContentContainer wrapperClassName={'list-issued-ticket'}>
      <ContentContainer.Header
        titleContent={'Danh sách chứng từ'}
        toolBar={
          <Space className="d-flex">
            <AppDnD
              defaultColumns={defaultColumns}
              localStorageName={PreferenceKeys.TvanHandleCompany}
            />
          </Space>
        }
      />
      <Space className="ml-5">
        <Space>
          <CustomAntInput
            type="search"
            borderRadius="sm"
            width={150}
            inputProps={{
              value: search,
              onChange: (e) => {
                setSearch(e.target.value)
                // set page is 1 when search
                setFilterParams({ page: 1 })
              },
            }}
          />
          {/* <CustomAntSelect
            className="adjustReplaceTicket-select"
            options={filterOptions}
            placeholder="Chọn tiêu chí tìm kiếm"
            value={tvanState.keySearch}
            onChange={(val) => handleChange({ key: 'keySearch', value: val })}
          /> */}
        </Space>
        <FilterPopover
          menuPosition="bottomLeft"
          defaultValues={defaultValuesAD()}
          savedKey={'gFiltersTvanHandle'}
          onApply={setFilterParams}
        />
      </Space>

      {/* toolBar=
        {
          <FilterPopover
            menuPosition="bottomLeft"
            defaultValues={defaultValues}
            savedKey={'gFiltersInvoiceList'}
            onApply={() => setFilterParams}
          />
        } */}
      {/* {renderInvoiceActionButtons()} */}
      {/* <FilterPopover
        menuPosition="bottomLeft"
        defaultValues={defaultValues}
        savedKey={'gFiltersInvoiceList'}
        onApply={() => setFilterParams}
      /> */}
      <ContentContainer.Body>
        {selectedAccountingDocument &&
          selectedAccountingDocument.length > 0 && (
            <div className="row">
              {buttonGroups.map((bg) => (
                <div className="col-sm-1" style={{ marginRight: '40px' }}>
                  <CustomAntButton
                    key={bg.text}
                    text={
                      bg.text + ' (' + selectedAccountingDocument.length + ')'
                    }
                    fontSizeText={12}
                    iconCn={bg.icon}
                    color={bg.color}
                    antProps={{
                      danger: bg.danger,
                      disabled:
                        bg.text == 'Nhân bản'
                          ? disableCopy
                          : disableChangeStatusRemoveInvoice,
                      type: bg.type ?? 'primary',
                      className: Utils.cn(
                        bg.className,
                        bg.disabled ? 'disabled' : '',
                      ),
                      onClick: bg.onClick,
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        <br />
        <CustomDataTable
          columns={dynamicColumns}
          dataSource={listData}
          isLoading={isGettingListData || isRefetching}
          isClickable
          handleDoubleClickRow={(row) => {}}
          pagination={{
            total: total,
            rowsPerPage: filterParams.limit,
            currentPage: filterParams.page,
            onChangePage: (page) => {
              setFilterParams({
                page,
              })
            },
            onChangeRowsPerPage: (limit) => {
              setFilterParams({
                limit,
                page: 1,
              })
            },
          }}
          isSelectable
          selectedRows={{
            clearSelectedRows: toggledClearRows,
            selectableRowSelected: (row) => {
              _.includes(selectedAccountingDocument, row)
            },
            handleSelectedRows: ({ selectedRows }) => {
              dispatch(setSelectedAccountingDocument(selectedRows))
            },
          }}
        />

        <ModalCompanyConfigs
          tvanState={tvanState}
          setTvanState={({ key, value }) => handleChange({ key, value })}
          modalsState={modalsState}
          setModalsState={setModalsState}
          refetchListInvoice={refetchListInvoice}
          row={tvanState.activeRow}
        />
      </ContentContainer.Body>
    </ContentContainer>
  )
}
